module.exports = __webpack_public_path__ + "static/img/quotes-transparent.30010225.svg";